/**
 * Created by dimah on 02/07/17.
 */
import { AbstractDTO } from "../models/dto/abstract";

export class UserNavigation extends AbstractDTO {
    static ATTR_NAME = "name";
    static ATTR_LINK = "link";
    static ATTR_ICON = "icon";

    name: string;
    link: string;
    icon: string;

    constructor(attributes?: object) {
        attributes = attributes ? attributes : {};
        super(attributes);

        this.name = attributes['name'] || "";
        this.link = attributes['link'] || "";
        this.icon = attributes['icon'] || "";
    }

}